export default "__VITE_ASSET__C24ExlUi__"